<template>
  <div class="outer screen text-center">
    <div class="center">
      <div v-if="!hasFirstName && !hasLastName">
        <PersonalDataScreen />
      </div>
      <div v-if="hasLastName && !hasEmail">
        <WorkDataScreen />
      </div>
      <!-- <div v-if="hasJobposition && !hasEmail">
        <CommunicationDataScreen />
      </div> -->
      <div v-if="hasEmail && !hasQuestionOne">
        <QuestionOneScreen />
      </div>
      <div v-if="hasQuestionOne && !hasQuestionTwo">
        <QuestionTwoScreen />
      </div>
      <div v-if="hasQuestionTwo && !hasQuestionGdpr">
        <QuestionGdprScreen />
      </div>
      <div v-if="hasQuestionGdpr && hasSavedData">
        <CodeScreen />
      </div>
      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
import PersonalDataScreen from "@/components/PersonalDataScreen.vue";
import WorkDataScreen from "@/components/WorkDataScreen.vue";
// import CommunicationDataScreen from "@/components/CommunicationDataScreen.vue";
import QuestionOneScreen from "@/components/QuestionOneScreen.vue";
import QuestionTwoScreen from "@/components/QuestionTwoScreen.vue";
import QuestionGdprScreen from "@/components/QuestionGdprScreen.vue";
import CodeScreen from "@/components/CodeScreen.vue";

export default {
  name: "HomeView",
  components: {
    PersonalDataScreen,
    WorkDataScreen,
    // CommunicationDataScreen,
    QuestionOneScreen,
    QuestionTwoScreen,
    QuestionGdprScreen,
    CodeScreen,
  },
  computed: {
    hasFirstName: function () {
      if (this.$store.getters.getFirstName === "") {
        return false;
      }
      return true;
    },
    hasLastName: function () {
      if (this.$store.getters.getLastName === "") {
        return false;
      }
      return true;
    },
    hasEmail: function () {
      if (this.$store.getters.getEmail === "") {
        return false;
      }
      return true;
    },
    hasJobposition: function () {
      if (this.$store.getters.getJobposition === "") {
        return false;
      }
      return true;
    },

    hasQuestionGdpr: function () {
      if (this.$store.getters.getQuestionGdpr === null) {
        return false;
      }
      return true;
    },
    hasQuestionOne: function () {
      if (this.$store.getters.getQuestionOne === null) {
        return false;
      }
      return true;
    },
    hasQuestionTwo: function () {
      if (this.$store.getters.getQuestionTwo === null) {
        return false;
      }
      return true;
    },
    hasSavedData: function () {
      if (this.$store.getters.getSavedData === null) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
html,
body {
  background-color: #4ec4cd;
  color: #000 !important;
  /* text-transform: uppercase; */
}
.screen {
  /* background: url("~@/assets/logo.png") no-repeat center center fixed; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  overflow: hidden; /* Hide scrollbars */
}
.outer {
  /* display: flex; */
  /* align-items: center; */
}
.center {
  /* margin: auto; */
  padding: 10px;
}
.logo {
  padding: 15px;
}
.bottom-spacer {
  padding: 100px;
}
* {
  border-radius: 1 !important;
}
</style>
